module.exports = __webpack_public_path__ + "static/contact_footer-04e2e3f673bec047bf2285b144f8b930.jpg";